import cloneDeep from 'lodash/cloneDeep';

import { UPDATE_DATA_NOTES_KEY } from 'src/redux/constants';
import type { IViewDataInitialState } from 'src/redux/viewData/types';

const SECTION_KEY = 'ACR_SECTIONS_DETAIL';

export const resetDataNotes = (
  state: IViewDataInitialState,
): IViewDataInitialState => ({
  ...state,
  [UPDATE_DATA_NOTES_KEY]: {
    ...state[UPDATE_DATA_NOTES_KEY],
    data: {
      message: '',
    },
  },
});

export const receiveDataNotes = (
  state: IViewDataInitialState,
  action: { payload: { data_notes: string } },
): IViewDataInitialState => {
  const newState = cloneDeep(state);
  newState[SECTION_KEY].data.data_notes = action.payload.data_notes;
  return newState;
};
